export default {"src":"/_next/static/media/white_logo.e9442956.svg","height":63,"width":45,"blurWidth":0,"blurHeight":0};